/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconElevator = createReactComponent("outline", "elevator", "IconElevator", [["path", { "d": "M5 4m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2l2 2", "key": "svg-1" }], ["path", { "d": "M10 14l2 2l2 -2", "key": "svg-2" }]]);

export { IconElevator as default };
//# sourceMappingURL=IconElevator.mjs.map
